export default __webpack_public_path__ + "static/media/complete.4a22322f.svg";